__turbopack_context__.v({
  "styleGuideFooter": "TJ09Lq_styleGuideFooter",
});
